import React, { useState, useMemo } from "react";
import { Toaster } from "sonner";
import TaskPanel from "./TaskPanel";
import MapPanel from "./MapPanel";
import AgentPanel from "./AgentPanel";
import AssignDriverModal from "./AssignDriverModal";
import TaskDetailsModal from "./TaskDetailsModal";
import SendNotificationModal from "../../Driver/SendNotificationModal";

export default function MapDashboardOld(props) {
  const {
    tasks,
    agents,
    isLoading,
    setFromDate,
    setToDate,
    FetchTaskCall,
    FetchDriverCall,
    fetchTaskLogs,
    handleChangeStatus,
    SyncWithAnlook,
    AssignTaskToDriver,
    handleToggle,
    isChecked,
    baseurl,
    token,
    setIsUnauthorised,
    fetchCustomerInstructions,
    instructionTaskIds,
  } = props;

  const [selectedTaskTab, setSelectedTaskTab] = useState("unassigned");
  const [selectedAgentTab, setSelectedAgentTab] = useState("active");
  const [searchQuery, setSearchQuery] = useState("");

  const [showAssignModal, setShowAssignModal] = useState(false);
  const [taskToAssign, setTaskToAssign] = useState(null);
  const [selectedAgentId, setSelectedAgentId] = useState("");

  const [selectedTask, setSelectedTask] = useState(null);
  const [showDetailsModal, setShowDetailsModal] = useState(false);

  const [notificationModalOpen, setNotificationModalOpen] = useState(false);
  const [notificationAgent, setNotificationAgent] = useState(null);

  const [assignmentLogs, setAssignmentLogs] = useState([]);
  const [statusChangeLogs, setStatusChangeLogs] = useState([]);
  const [showLogs, setShowLogs] = useState(false);

  const [instructionModalOpen, setInstructionModalOpen] = useState(false);
  const [taskInstructions, setTaskInstructions] = useState([]);
  const [loadingInst, setLoadingInst] = useState(false);

  const handleInstructionClick = async (taskId) => {
    setLoadingInst(true);

    const allData = await fetchCustomerInstructions();

    const onlyThisTask = (allData || []).filter(
      (i) => String(i.task_id) === String(taskId),
    );

    setTaskInstructions(onlyThisTask);
    setInstructionModalOpen(true);
    setLoadingInst(false);
  };

  // ---------- FILTER TASKS  ----------
  const filteredTasks = useMemo(() => {
    if (!tasks) return [];

    if (selectedTaskTab === "unassigned") {
      return tasks.filter((task) => task.status === "unassigned");
    }

    if (selectedTaskTab === "successful") {
      return tasks.filter((task) => task.status === "successful");
    }

    return tasks.filter(
      (task) => !["unassigned", "successful"].includes(task.status),
    );
  }, [tasks, selectedTaskTab]);

  // ---------- FILTER AGENTS ----------
  const filteredAgents = useMemo(() => {
    let list =
      selectedAgentTab === "total"
        ? agents
        : agents.filter(
            (a) => a.dutyStatus?.toLowerCase() === selectedAgentTab,
          );

    return list.filter((a) =>
      a.fullName?.toLowerCase().includes(searchQuery.toLowerCase()),
    );
  }, [agents, selectedAgentTab, searchQuery]);

  const handleOpenTaskDetails = (task) => {
    setSelectedTask(task);
    setShowDetailsModal(true);
    setAssignmentLogs([]);
    setStatusChangeLogs([]);
    setShowLogs(false);
  };

  return (
    <div className="flex w-full h-full overflow-hidden">
      <Toaster position="top-right" />

      {/* LEFT PANEL */}
      <TaskPanel
        tasks={tasks}
        filteredTasks={filteredTasks}
        isLoading={isLoading}
        selectedTaskTab={selectedTaskTab}
        setSelectedTaskTab={setSelectedTaskTab}
        setTaskToAssign={setTaskToAssign}
        setShowAssignModal={setShowAssignModal}
        setSelectedTask={handleOpenTaskDetails}
        setShowDetailsModal={setShowDetailsModal}
        SyncWithAnlook={SyncWithAnlook}
        FetchTaskCall={FetchTaskCall}
        setFromDate={setFromDate}
        setToDate={setToDate}
        handleToggle={handleToggle}
        isChecked={isChecked}
        onInstructionClick={handleInstructionClick}
        instructionTaskIds={instructionTaskIds}
      />

      {/* MIDDLE MAP */}
      <MapPanel tasks={tasks} agents={agents} />

      {/* RIGHT AGENTS */}
      <AgentPanel
        agents={agents}
        filteredAgents={filteredAgents}
        selectedAgentTab={selectedAgentTab}
        setSelectedAgentTab={setSelectedAgentTab}
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        FetchDriverCall={FetchDriverCall}
        setNotificationAgent={setNotificationAgent}
        setNotificationModalOpen={setNotificationModalOpen}
      />

      {/* ASSIGN DRIVER MODAL */}
      {showAssignModal && taskToAssign && (
        <AssignDriverModal
          task={taskToAssign}
          teamDrivers={[]}
          allTeamDrivers={agents}
          selectedAgentId={selectedAgentId}
          setSelectedAgentId={setSelectedAgentId}
          onClose={() => setShowAssignModal(false)}
          onAssign={async (taskId, driverId) => {
            await AssignTaskToDriver(taskId, driverId);
            setShowAssignModal(false);
            FetchTaskCall();
          }}
        />
      )}

      {/* TASK DETAILS MODAL */}
      {showDetailsModal && selectedTask && (
        <>
          {console.log("Rendering TaskDetailsModal with:", {
            assignmentLogs,
            statusChangeLogs,
            assignmentLogsLength: assignmentLogs.length,
            statusChangeLogsLength: statusChangeLogs.length,
            taskId: selectedTask.pk_task_id,
          })}

          <TaskDetailsModal
            show={showDetailsModal}
            task={selectedTask}
            onClose={() => setShowDetailsModal(false)}
            assignmentLogs={assignmentLogs}
            statusChangeLogs={statusChangeLogs}
            showLogs={showLogs}
            setShowLogs={setShowLogs}
            onFetchLogs={async (taskId) => {
              const data = await fetchTaskLogs(taskId);
              setAssignmentLogs(data.assignmentLogs);
              setStatusChangeLogs(data.statusChangeLogs);
            }}
            onStatusChange={async (taskId, newStatus) => {
              const success = await handleChangeStatus(
                taskId,
                newStatus,
                selectedTask?.driver_id,
              );

              if (success) {
                setShowDetailsModal(false);
              }
            }}
          />
        </>
      )}

      {instructionModalOpen && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
          <div className="bg-white p-5 rounded-xl w-[520px] shadow-lg">
            <h2 className="text-lg font-bold mb-3">Customer Instructions</h2>

            {loadingInst ? (
              <p>Loading...</p>
            ) : Array.isArray(taskInstructions) &&
              taskInstructions.length > 0 ? (
              taskInstructions.map((i) => (
                <div
                  key={i.pk_customer_delivery_instruction_id}
                  className="mb-3 border-b pb-3"
                >
                  <p className="font-semibold text-base">
                    {i.instuction_title || "Instruction"}
                  </p>

                  <p className="text-sm text-gray-600 mt-1">
                    <strong>Default note:</strong>{" "}
                    {i.instuction_description || "No description"}
                  </p>

                  {i.customer_instruction_messege && (
                    <p className="text-sm text-orange-700 mt-1">
                      <strong>Customer message:</strong>{" "}
                      {i.customer_instruction_messege}
                    </p>
                  )}

                  <p className="text-xs text-gray-600 mt-1">
                    Shop: {i.shop_name || "N/A"} • Task: {i.task_id}
                  </p>
                </div>
              ))
            ) : (
              <p className="text-gray-500">No instructions for this task.</p>
            )}

            <div className="mt-3 flex justify-end">
              <button
                onClick={() => {
                  setInstructionModalOpen(false);
                  setTaskInstructions([]);
                }}
                className="bg-red-500 text-white px-4 py-2 rounded"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* SEND NOTIFICATION */}
      <SendNotificationModal
        isOpen={notificationModalOpen}
        onClose={() => setNotificationModalOpen(false)}
        driver={notificationAgent}
        baseurl={baseurl}
        token={token}
        setIsUnauthorised={setIsUnauthorised}
      />
    </div>
  );
}
